import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

const LOJA = "Giraia Bike Shop";
const EMAIL = "giragirabike@gmail.com";
const WHATSAPP = "(66) 99958-4198";
const ENDERECO = "Avenida Ademar Raiter, 438, Sorriso - MT";
const DATA = "14 de outubro de 2026";

function Secao({ titulo, children }) {
  return (
    <section>
      <h2 className="text-[#E2B84A] text-xl font-black mt-5 mb-2">{titulo}</h2>
      {children}
    </section>
  );
}

const TermosUsoPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-[#E7E3EC]">
      <div className="max-w-3xl mx-auto p-6">
        <Link to="/" className="inline-flex items-center gap-2 text-[#E2B84A] mb-6 text-sm font-bold">
          <ArrowLeft size={18} /> Voltar
        </Link>
        <div className="flex items-center gap-3 mb-2">
          <FileText className="w-8 h-8 text-[#E2B84A]" />
          <h1 className="text-4xl font-black text-white">Termos de Uso</h1>
        </div>
        <p className="text-[#716A80] text-sm mb-8">Atualizado em {DATA}</p>
        <div className="space-y-5 text-sm leading-relaxed">
          <section className="bg-[#E2B84A]/10 border border-[#E2B84A]/40 rounded-lg p-4">
            <p><strong className="text-[#E2B84A]">Resumo rápido:</strong> Ao comprar na loja ou fazer o curso, você concorda com estas regras. Você pode desistir da compra em até 7 dias. O curso é educativo e não substitui as leis de trânsito.</p>
          </section>
          <Secao titulo="1. Quem somos">
            <p>{LOJA} · {ENDERECO}. Contato: {EMAIL} · WhatsApp {WHATSAPP}.</p>
          </Secao>
          <Secao titulo="2. A loja">
            <p>Os produtos, preços e a disponibilidade podem mudar sem aviso. A compra, a retirada ou a entrega são combinadas pelo WhatsApp. Fotos são ilustrativas.</p>
          </Secao>
          <Secao titulo="3. O curso de scooter">
            <p>O curso tem 5 módulos: Legislação 2026, Segurança na Prática, Trânsito Urbano de Sorriso, Manutenção Básica e Aula Prática + Certificação. Os módulos 2 a 4 custam R$ 29,90 cada e o módulo 5 custa R$ 49,90 (preço de lançamento até 30/11/2026; depois, R$ 69,90 e R$ 99,90). O módulo 1 é gratuito. O acesso é pessoal e não pode ser compartilhado ou revendido. A aula prática é presencial e agendada pelo WhatsApp.</p>
          </Secao>
          <Secao titulo="4. Pagamento">
            <p>O pagamento é feito por PIX. Depois que conferimos o pagamento, o módulo é liberado, em até 24 horas. Guarde o comprovante.</p>
          </Secao>
          <Secao titulo="5. Desistência em 7 dias">
            <p>Para compras feitas à distância, você pode desistir em até 7 dias corridos, conforme o art. 49 do Código de Defesa do Consumidor. Peça pelo WhatsApp {WHATSAPP} ou pelo e-mail {EMAIL}, e devolvemos o valor pago.</p>
          </Secao>
          <Secao titulo="6. Certificado">
            <p>O certificado é emitido quando você conclui as etapas do curso, incluindo a aula prática. Ele tem um código de validação.</p>
          </Secao>
          <Secao titulo="7. Menores de 18 anos">
            <p>Menores de 18 anos só podem se cadastrar com ciência e autorização de um responsável.</p>
          </Secao>
          <Secao titulo="8. Suas responsabilidades">
            <p>Informe dados verdadeiros, não compartilhe sua senha e respeite a legislação de trânsito. O curso tem caráter educativo e não substitui o dever de cada pessoa de seguir as leis e de usar os equipamentos de segurança.</p>
          </Secao>
          <Secao titulo="9. Seus dados">
            <p>Veja como cuidamos dos seus dados na <Link to="/privacidade" className="text-[#E2B84A] font-bold">Política de Privacidade</Link>.</p>
          </Secao>
          <Secao titulo="10. Mudanças e foro">
            <p>Podemos atualizar estes termos, e a data no topo mostra a versão em vigor. Fica eleito o foro da comarca de Sorriso-MT, sem prejuízo do direito do consumidor de acionar o foro do seu domicílio.</p>
          </Secao>
        </div>
      </div>
    </div>
  );
};

export default TermosUsoPage;
